import { render, staticRenderFns } from "./DuplicateIcon.vue?vue&type=template&id=2ac2c31e&scoped=true"
import script from "./DuplicateIcon.vue?vue&type=script&lang=js"
export * from "./DuplicateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2c31e",
  null
  
)

export default component.exports